import React from "react";
import { Link } from "react-router-dom";

import "../css/manualestarjetas.css";

const ManualesTarjeta = (props) => {
  const { titulo, text, page } = props;

  return (
    <div className="ManualesTarjeta">
      <Link className="card cardManuales shadow-sm" to={page}>
        <div className="card-body p-3">
          <h4 className="card-title">
            <svg
              className="pb-1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width={24}
              height={24}
              color={"#1A7F46"}
              fill={"none"}
            >
              <path
                d="M4 17.9808V9.70753C4 6.07416 4 4.25748 5.17157 3.12874C6.34315 2 8.22876 2 12 2C15.7712 2 17.6569 2 18.8284 3.12874C20 4.25748 20 6.07416 20 9.70753V17.9808C20 20.2867 20 21.4396 19.2272 21.8523C17.7305 22.6514 14.9232 19.9852 13.59 19.1824C12.8168 18.7168 12.4302 18.484 12 18.484C11.5698 18.484 11.1832 18.7168 10.41 19.1824C9.0768 19.9852 6.26947 22.6514 4.77285 21.8523C4 21.4396 4 20.2867 4 17.9808Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            &nbsp;Manual de {titulo}
          </h4>
          <p className="card-text text-secondary">{text}</p>
        </div>
      </Link>
    </div>
  );
};

export default ManualesTarjeta;
